import React from "react";
import { LinearProgress, Stack, Box, Tooltip, Typography } from "@mui/material";

export default function MultiSegmentProgressBar({
  tenure = 0,
  paid = 0,
  overdue = 0,
}) {
  const paidPercentage = (paid / tenure) * 100;
  const overduePercentage = (overdue / tenure) * 100;
  return (
    <Stack rowGap={1} sx={{ width: "100%" }}>
      <Box>
        <Tooltip title={`${paid} Months Paid`} arrow>
          <LinearProgress
            variant="determinate"
            value={paidPercentage || 0}
            sx={{
              height: 10,
              borderRadius: 2,
              "& .MuiLinearProgress-bar": {
                backgroundColor: "green",
              },
            }}
          />
        </Tooltip>
        <Typography
          variant="caption"
          sx={{
            color: "green",
            textAlign: "center",
            display: "block",
            mt: 0.5,
          }}
        >
          {`${paid} Months Paid`}
        </Typography>
      </Box>
      <Box>
        <Tooltip title={`${overdue} Months Overdue`} arrow>
          <LinearProgress
            variant="determinate"
            value={overduePercentage || 0}
            sx={{
              height: 10,
              borderRadius: 2,
              "& .MuiLinearProgress-bar": {
                backgroundColor: "#ED1C24",
              },
            }}
          />
        </Tooltip>
        <Typography
          variant="caption"
          sx={{
            color: "#ED1C24",
            textAlign: "center",
            display: "block",
            mt: 0.5,
          }}
        >
          {`${overdue} Months Overdue`}
        </Typography>
      </Box>
      {/* <Box>
        <Tooltip title={`${tenure - paid - overdue} Months Upcoming`} arrow>
          <LinearProgress
            variant="determinate"
            value={100 - upcomingPercentage}
            sx={{
              height: 10,
              borderRadius: 2,
              "& .MuiLinearProgress-bar": {
                backgroundColor: "grey",
              },
            }}
          />
        </Tooltip>
        <Typography
          variant="caption"
          sx={{
            color: "grey",
            textAlign: "center",
            display: "block",
            mt: 0.5,
          }}
        >
          {`${tenure - paid - overdue} Months Upcoming`}
        </Typography>
      </Box> */}
    </Stack>
  );
}
